module.exports = __webpack_public_path__ + "kiavi-loading-v1-975f4da.gif";